// @flow
import {useSelector} from 'react-redux';
import type {RootState} from '../..';
import type {Store} from '../../../entities/store';

export function getTierName(source: Store | string) {
  let tierName;

  if (typeof source === 'object') {
    tierName = source.storeTier.name;
  } else {
    tierName = source;
  }

  switch (tierName) {
    case 'TIER_3':
    case 'TIER_31':
    case 'TIER_11':
    case 'TIER_33':
      return 'TiendaDa PRO';
    case 'TIER_309':
    case 'TIER_310':
      return 'TiendaDa Básico';
    case 'TIER_109':
      return 'TiendaDa Básico (Periodo de prueba)';
    case 'TIER_110':
      return 'TiendaDa Básico (Periodo de prueba)';
    case 'TIER_120':
      return 'TiendaDa PRO+ (Periodo de prueba)';
    case 'TIER_150':
      return 'TiendaCHAT (Periodo de prueba)';
    case 'TIER_320':
      return 'TiendaDa PRO+';
    case 'TIER_350':
      return 'TiendaCHAT';

    case 'TIER_360':
      return 'TiendaBOT';
    case 'TIER_160':
      return 'TiendaBOT (Periodo de prueba)';

    default:
      return 'TiendaDa';
  }
}

export const MAP_SINGLE_PLAN_NAME = {
  TIER_11: 'Básico',
  TIER_22: 'Básico',
  TIER_109: 'Básico',
  TIER_110: 'Básico',
  TIER_120: 'PRO+',
  TIER_210: 'Básico',
  TIER_220: 'PRO+',
  TIER_309: 'Básico',
  TIER_310: 'Básico',
  TIER_320: 'PRO+',
  TIER_409: 'Básico',
  TIER_410: 'Básico',
  TIER_420: 'Básico',
};

export const MAP_FREE_TRIAL_NAME = {
  TIER_11: '(Periodo de prueba)',
  TIER_109: '(Periodo de prueba)',
  TIER_110: '(Periodo de prueba)',
  TIER_120: '(Periodo de prueba)',
  TIER_150: '(Periodo de prueba)',
};

const storeSelector = (state: RootState) =>
  state.store.store && state.store.store.storeTier.name;

export function useTierStoreName() {
  const storeTierName = useSelector(storeSelector);

  return storeTierName;
}
